import { P2GBox } from '@parcel2go/core-ui';
import Loading from '../../../../components/loading/Loading';

export interface processingProps {
  processing: boolean;
  className?: string | undefined;
  children: React.ReactNode;
}

const SmartSendProcessing: React.FC<processingProps> = (props) => {
  if (!props.processing) {
    return <div className={props.className}>{props.children}</div>;
  }

  return (
    <div style={{ position: 'relative' }} className={props.className}>
      <P2GBox
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          position: 'absolute',
          width: '100%',
          top: 0,
          zIndex: 1,
          backgroundColor: 'rgba(255,255,255,0.8)'
        }}
      >
        <Loading />
      </P2GBox>
      {props.children}
    </div>
  );
};

export { SmartSendProcessing };
